// Theme colors for the chat application
const defaultColors = {
  // Background colors
  background: '#D8DAE5',
  inputBackground: '#FFFFFF',
  
  // Border colors
  border: '#444',
  
  // Message bubbles
  botBubble: '#FFFFFF',
  userBubble: '#db0d0d',
  
  // Text colors
  userText: '#FFFFFF',
  botText: '#1B1C1F',
  
  // Link colors
  userLink: '#000080',
  botLink: '#000000',
  
  // Button colors
  buttonHover: '#db0d0d',
  
  // Widget specific
  widgetButtonBg: '#db0d0d',
  widgetButtonHover: '#db0d0d',
  widgetTextColor: '#FFFFFF',
  widgetShadow: 'rgba(0, 0, 0, 0.3)',
  widgetHeaderBg: '#FFFFFF',
  widgetText: 'AI Bot',
  headerText: 'Chat Assistant',
};
let ThemeColors = defaultColors;
// API base URL - should be configurable based on environment
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Fetch colors from the BE API using client GUID
export const fetchThemeColors = async (clientGuid: string): Promise<typeof defaultColors> => {
  if (!clientGuid) {
    console.warn('No client GUID provided for fetching theme colors');
    return defaultColors;
  }

  try {
    // Make an API call to get colors from the backend
    const response = await fetch(`${API_BASE_URL}/api/clients/guid/${clientGuid}/colors`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch colors: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    
    // Map the response data to our color structure
    // This ensures we have fallbacks for any missing properties
    return {
      ...defaultColors,
      background: data.background || defaultColors.background,
      inputBackground: data.input_background || defaultColors.inputBackground,
      border: data.border || defaultColors.border,
      botBubble: data.bot_bubble || defaultColors.botBubble,
      userBubble: data.user_bubble || defaultColors.userBubble,
      userText: data.user_text || defaultColors.userText,
      botText: data.bot_text || defaultColors.botText,
      userLink: data.user_link || defaultColors.userLink,
      botLink: data.bot_link || defaultColors.botLink,
      buttonHover: data.button_hover || defaultColors.buttonHover,
      widgetButtonBg: data.widget_button_bg || defaultColors.widgetButtonBg,
      widgetButtonHover: data.widget_button_hover || defaultColors.widgetButtonHover,
      widgetTextColor: data.widget_text_color || defaultColors.widgetTextColor,
      widgetShadow: data.widget_shadow || defaultColors.widgetShadow,
      widgetHeaderBg: data.widget_header_bg || defaultColors.widgetHeaderBg, 
      widgetText: data.widget_text || defaultColors.widgetText,
      headerText: data.header_text || defaultColors.headerText,
    };
  } catch (error) {
    console.error('Failed to fetch theme colors:', error);
    return defaultColors;
  }
};

// Export the default colors for initial state
export const colors = defaultColors; 